/**
 * Integration Management React App Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import IntegrationManagement from '../../components/integrations/IntegrationManagement';

// Import styles - REQUIRED for proper formatting
import '../styles/index.scss';

// Import core utilities and components for sidebar/theme functionality
import { DOM } from './utils/dom.js';
import ThemeManager from './utils/theme.js';
import Sidebar from './components/Sidebar.js';
import authService from './auth/authService.js';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize core components (sidebar, theme, etc.)
  if (DOM.exists('.sidebar')) {
    new Sidebar();
  }
  
  // Initialize theme manager
  ThemeManager.init();
  
  // Initialize logout handlers
  const logoutBtn = document.getElementById('logoutBtn');
  const headerLogoutBtn = document.getElementById('headerLogoutBtn');
  
  if (logoutBtn) {
    logoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      authService.logout();
    });
  }
  
  if (headerLogoutBtn) {
    headerLogoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      authService.logout();
    });
  }
  
  // Initialize the React app
  const rootElement = document.getElementById('integration-root');
  
  if (rootElement) {
    // Create React root and render the Integration Management component
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <IntegrationManagement />
      </React.StrictMode>
    );
  }
});